"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryClient = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const react_query_devtools_1 = require("@tanstack/react-query-devtools");
const axios_1 = require("axios");
const react_1 = require("react");
const react_router_1 = require("react-router");
const cookieUtils_1 = require("../components/cookies/cookieUtils");
const notification_1 = __importDefault(require("../components/molecules/notification"));
const pageSpinner_1 = __importDefault(require("../components/molecules/pageSpinner"));
const alertDialog_1 = __importDefault(require("../components/organisms/alertDialog"));
const sideMenu_1 = __importDefault(require("../components/organisms/sideMenu"));
const tsGoTheme_1 = require("../material-ui-theme/tsGoTheme");
const query_keys_1 = require("../queries/query-keys");
const sessionQuery_1 = require("../queries/sessionQuery");
const setTime_1 = require("../utils/setTime");
const usePortal_1 = __importDefault(require("../utils/usePortal"));
const zustandStore_1 = require("../zustandStore");
const GoApp_1 = require("./GoApp");
const routerUtils_1 = require("./routerUtils");
const cookie_1 = require("./routes/cookie");
const ReactQueryDevtoolsProduction = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('@tanstack/react-query-devtools/build/modern/production.js'))).then(d => ({
    default: d.ReactQueryDevtools,
})));
// disable focus manager for tanstack-query
// so when switching tabs it does not refetch data
react_query_1.focusManager.setFocused(false);
exports.queryClient = new react_query_1.QueryClient({
    defaultOptions: {
        queries: {
            enabled: false, // disbaled so we do not make unathorized use requests
            refetchOnWindowFocus: false,
            staleTime: (0, setTime_1.setTime)(1, 'minutes'),
            throwOnError: (error, query) => {
                if (error instanceof axios_1.AxiosError &&
                    (error.response?.status === 401 || error.response?.status === 403) &&
                    (query.queryKey[0] === query_keys_1.userKeys.getUser || query.queryKey[0] === sessionQuery_1.sessionKeys.getStatus()) &&
                    globalThis.location.pathname !== '/' &&
                    !GoApp_1.excludedPaths.includes(globalThis.location.pathname)) {
                    (0, routerUtils_1.savePreLoginRouterState)({
                        redirectTo: globalThis.location.pathname,
                        redirectParams: globalThis.location.search,
                    });
                    // Navigate to login page
                    (0, react_router_1.Navigate)({ to: '/signin/login' });
                    return false;
                }
                if (error instanceof axios_1.AxiosError) {
                    return error.response?.status ? error.response.status >= 500 : false;
                }
                return false;
            },
        },
    },
});
const Root = ({ children }) => {
    const navigation = (0, react_router_1.useNavigation)();
    const location = (0, react_router_1.useLocation)();
    const [showDevtools, setShowDevtools] = (0, react_1.useState)(false);
    const isInExcludedList = GoApp_1.excludedPaths.some(path => globalThis.location.pathname.includes(path));
    const shouldRenderSideMenu = globalThis.location.pathname !== '/' && !isInExcludedList;
    exports.queryClient.setDefaultOptions({
        queries: {
            enabled: shouldRenderSideMenu,
        },
    });
    const { setIsCookieCutterOpen, pageSpinner, cookies } = (0, zustandStore_1.useZustand)(state => ({
        ...state,
    }));
    const { isLoading: isPageLoading } = pageSpinner;
    const NotificationPortal = (0, usePortal_1.default)('notificationWrapper', (0, jsx_runtime_1.jsx)(notification_1.default, {}));
    const DialogPortal = (0, usePortal_1.default)('dialogWrapper', (0, jsx_runtime_1.jsx)(alertDialog_1.default, {}));
    (0, react_1.useEffect)(() => {
        globalThis.toggleDevtools = () => setShowDevtools(old => !old);
    }, []);
    (0, react_1.useEffect)(() => {
        if (!shouldRenderSideMenu) {
            return;
        }
        const menuWrapper = document.querySelector('#main-sideMenu');
        const hasOpenChild = menuWrapper?.querySelector('.side-menu-open');
        const collapsedChildren = menuWrapper?.querySelectorAll('.side-menu-collapsed');
        const collapsedAndOpenChild = menuWrapper?.querySelector('.side-menu-collapsed .open');
        if (hasOpenChild) {
            menuWrapper?.classList.add('hasSidemenuOpen');
        }
        else {
            menuWrapper?.classList.remove('hasSidemenuOpen');
        }
        if (collapsedChildren && collapsedChildren.length >= 2) {
            menuWrapper?.classList.add('hasDoubleSidemenuCollapsed');
        }
        else {
            menuWrapper?.classList.remove('hasDoubleSidemenuCollapsed');
        }
        if (collapsedChildren && collapsedChildren.length >= 2 && collapsedAndOpenChild) {
            menuWrapper?.classList.add('hasCollapsedAndOpen');
        }
        else {
            menuWrapper?.classList.remove('hasCollapsedAndOpen');
        }
    }, [shouldRenderSideMenu]);
    (0, react_1.useEffect)(() => {
        if (globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP) {
            return;
        }
        if (!cookies.open && !(0, cookieUtils_1.areCookiesSaved)() && globalThis.location.pathname !== cookie_1.cookieNoticePath) {
            setIsCookieCutterOpen(true);
        }
    }, [cookies.open, location]);
    return ((0, jsx_runtime_1.jsxs)(react_query_1.QueryClientProvider, { client: exports.queryClient, children: [(0, jsx_runtime_1.jsxs)(material_1.ThemeProvider, { theme: tsGoTheme_1.customGoTheme, children: [(0, jsx_runtime_1.jsx)(material_1.CssBaseline, {}), shouldRenderSideMenu ? (0, jsx_runtime_1.jsx)(sideMenu_1.default, {}) : null, (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: NotificationPortal }), (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: DialogPortal }), (0, jsx_runtime_1.jsx)(pageSpinner_1.default, { isLoading: isPageLoading || navigation.state === 'loading' }), children] }), (0, jsx_runtime_1.jsx)(react_query_devtools_1.ReactQueryDevtools, { initialIsOpen: false, buttonPosition: globalThis.IS_PLAYWRIGHT_RUNNING ? 'top-left' : 'bottom-right' }), showDevtools && ((0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: null, children: (0, jsx_runtime_1.jsx)(ReactQueryDevtoolsProduction, {}) }))] }));
};
exports.default = Root;
